<div class="relative isolate grid grow items-center justify-items-center">
  <ng-content></ng-content>
</div>
